/** Identifiant stable pour les vignettes qui déclenchent une action sur la carte (évite de s’appuyer sur shortLabel / label). */
export const BUILDING_MAP_INTERACTION = {
  zonesSurveillees: "zonesSurveillees",
  historicMonumentsAround: "historicMonumentsAround",
  fireStation: "fireStation",
  gasStation: "gasStation",
} as const;

export type BuildingMapInteraction =
  (typeof BUILDING_MAP_INTERACTION)[keyof typeof BUILDING_MAP_INTERACTION];
